import {
  Overlay,
  ModalContainer,
  CloseButton,
  Title,
  Steps,
  Step,
  IconWrapper,
  StepText,
  StepTitle,
  TipBox
} from './style'
import { FiMonitor, FiFileText, FiEye, FiX } from 'react-icons/fi'

interface ModalMargensProps {
  onClose: () => void
}

function ModalMargens({ onClose }: ModalMargensProps) {
  return (
    <Overlay>
      <ModalContainer>
        <CloseButton onClick={onClose}>
          <FiX size={20} />
        </CloseButton>
        <Title>Como consultar suas margens no Meu INSS</Title>
        <Steps>
          <Step>
            <IconWrapper color="#007bff">
              <FiMonitor size={20} color="white" />
            </IconWrapper>
            <div>
              <StepTitle>1. Acesse o Meu INSS</StepTitle>
              <StepText>
                Utilize o site ou aplicativo Meu INSS (disponível para Android e
                iOS).
              </StepText>
            </div>
          </Step>

          <Step>
            <IconWrapper color="#28a745">
              <span className="span">2</span>
            </IconWrapper>
            <div>
              <StepTitle>2. Faça login</StepTitle>
              <StepText>Insira seu CPF e senha do Gov.br.</StepText>
            </div>
          </Step>

          <Step>
            <IconWrapper color="#ffc107">
              <FiFileText size={20} color="white" />
            </IconWrapper>
            <div>
              <StepTitle>3. Procure por Extrato</StepTitle>
              <StepText>
                Busque por Extrato de Empréstimo ou Extrato de Pagamento no
                menu.
              </StepText>
            </div>
          </Step>

          <Step>
            <IconWrapper color="#6f42c1">
              <FiEye size={20} color="white" />
            </IconWrapper>
            <div>
              <StepTitle>4. Verifique as informações</StepTitle>
              <StepText>
                O extrato mostrará sua margem consignável disponível para
                empréstimos e cartão.
              </StepText>
            </div>
          </Step>
        </Steps>
        <TipBox>
          💡 <strong>Dica:</strong> Você pode baixar o app Meu INSS na Google
          Play Store ou App Store para consultar de qualquer lugar.
        </TipBox>
      </ModalContainer>
    </Overlay>
  )
}

export default ModalMargens
